// extracted by mini-css-extract-plugin
export default {"link":"FastGoldLink_link","withIcon":"FastGoldLink_withIcon"};